import { createAction, props } from '@ngrx/store';


export const listMembersSearch = createAction(
    '[Search Members] list',
    props <{stringSearch: string}>()
);

export const listMembersSearchSuccess = createAction(
    '[Search Members] list success',
    props <{memberList: any}>()
);

export const listMemberReset = createAction(
    '[List Member Reset]'
);

export const listMemberResetSuccess = createAction(
    '[List Member Reset] Success'
);
